import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { graphqlRequest } from '@/service/graphqlClient.ts'
import {
  AdmitAttendeeDocument,
  MarkAttendeeAttendedDocument,
  MarkAttendeeNoShowDocument,
  UpdateRegistrationDocument,
  type UpdateRegistrationMutationVariables,
  type UpdateRegistrationPayload,
  WaitlistAttendeeDocument,
} from '@/gql/graphql.ts'
import { QUERY_KEY_ILT_REGISTRATIONS } from '@/queries/iltRegistrations/iltRegistrationKeys.ts'

export const useAdmitAttendeeMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (registrationId) =>
      graphqlRequest(AdmitAttendeeDocument, { registrationId }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [QUERY_KEY_ILT_REGISTRATIONS],
      })
    },
  })
}

export const useMarkAttendeeNoShowMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (registrationId) =>
      graphqlRequest(MarkAttendeeNoShowDocument, { registrationId }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [QUERY_KEY_ILT_REGISTRATIONS],
      })
    },
  })
}

export const useMarkAttendeeAttendedMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (registrationId) =>
      graphqlRequest(MarkAttendeeAttendedDocument, { registrationId }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [QUERY_KEY_ILT_REGISTRATIONS],
      })
    },
  })
}

export const useWaitListAttendeeMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (registrationId) =>
      graphqlRequest(WaitlistAttendeeDocument, { registrationId }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [QUERY_KEY_ILT_REGISTRATIONS],
      })
    },
  })
}

export const useUpdateRegistrationMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (
      updateRegistrationMutationVariables: UpdateRegistrationMutationVariables
    ): UpdateRegistrationPayload => {
      return graphqlRequest(
        UpdateRegistrationDocument,
        updateRegistrationMutationVariables
      )
    },

    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [QUERY_KEY_ILT_REGISTRATIONS],
      })
    },
  })
}
